// extracted by mini-css-extract-plugin
module.exports = {"main-component":"bulb_main-component__Yg5NM"};